import {entitiesCopyHelper} from "@/utils";

export default {
    methods: {
        copyEntitiesFrom(fieldId) {
            const value = this.fieldIdToValueMaps[fieldId].concat();
            entitiesCopyHelper.setCopyObj({
                projectId: this.projectId,
                value
            })
        },
        pasteEntitiesTo(fieldId) {
            const obj = entitiesCopyHelper.getCopyObj();
            if (!obj) {
                alert('It seems you haven\'t copied any entities!')
                return;
            }
            const {projectId, value} = obj;
            if (projectId !== this.projectId) {
                alert('It seems you have copied from a different project!')
                return;
            }
            this.setInputValue(fieldId, value, true);
        }
    },
}
